export const rainDataNew = [
  {
    quarter: "Summer 2018",
    rainfall: 72.73,
    elNino: -2,
  },
  {
    quarter: "Autumn 2018",
    rainfall: 31.9,
    elNino: 0.33,
  },
  {
    quarter: "Winter 2018",
    rainfall: 14.2,
    elNino: 1,
  },
  {
    quarter: "Spring 2018",
    rainfall: 121.93,
    elNino: 2,
  },
  {
    quarter: "Summer 2019",
    rainfall: 122.6,
    elNino: 1.33,
  },
  {
    quarter: "Autumn 2019",
    rainfall: 38.8,
    elNino: 1.33,
  },
  {
    quarter: "Winter 2019",
    rainfall: 28.33,
    elNino: 0.44,
  },
  {
    quarter: "Spring 2019",
    rainfall: 20.93,
    elNino: 0,
  },
  {
    quarter: "Summer 2020",
    rainfall: 202.27,
    elNino: 0,
  },
  {
    quarter: "Autumn 2020",
    rainfall: 48.73,
    elNino: 0,
  },
  {
    quarter: "Winter 2020",
    rainfall: 81,
    elNino: -0.67,
  },
  {
    quarter: "Spring 2020",
    rainfall: 82.53,
    elNino: -2.67,
  },
  {
    quarter: "Summer 2021",
    rainfall: 178.4,
    elNino: -3,
  },
  {
    quarter: "Autumn 2021",
    rainfall: 40.13,
    elNino: -1,
  },
  {
    quarter: "Winter 2021",
    rainfall: 43.67,
    elNino: 0,
  },
  {
    quarter: "Spring 2021",
    rainfall: 101.8,
    elNino: -1.67,
  },
  {
    quarter: "Summer 2022",
    rainfall: 318.33,
    elNino: -3,
  },
  {
    quarter: "Autumn 2022",
    rainfall: 80.6,
    elNino: -3,
  },
  {
    quarter: "Winter 2022",
    rainfall: 151.47,
    elNino: -1.67,
  },
  {
    quarter: "Spring 2022",
    rainfall: 75.53,
    elNino: -3,
  },
  {
    quarter: "Summer 2023",
    rainfall: 128.47,
    elNino: -3,
  },
  {
    quarter: "Autumn 2023",
    rainfall: 48.6,
    elNino: -3,
  },
]
